import { render } from "./MenuFooter.vue?vue&type=template&id=1e8143f4&scoped=true"
import script from "./MenuFooter.vue?vue&type=script&lang=js"
export * from "./MenuFooter.vue?vue&type=script&lang=js"

import "./MenuFooter.vue?vue&type=style&index=0&id=1e8143f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8143f4"]])

export default __exports__